<cs-data-entry-state [renderSchema]="renderSchema" (onActionRequested)="onActionRequestedHandler($event)" ></cs-data-entry-state>
